// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>3</span>&nbsp;&nbsp;For your love is before my eyes;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;I have walked in your truth.<br> </p> </div></div>";
// Exports
module.exports = code;